// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38d9E","col":"styles_col__3dLDO"};